import { render, staticRenderFns } from "./NewPasswordForm.vue?vue&type=template&id=81ba0314"
import script from "./NewPasswordForm.vue?vue&type=script&lang=ts"
export * from "./NewPasswordForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports